import Image from 'next/image';

import {
  EPICExplanationWithoutTooltip,
  ProgressBar,
  Text
} from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import {
  generateEPICExplanationAndCopyToClipboard,
  getEPICGenerationCompletionPercentage
} from '@/services/myEvents.service';

const EPICBriefHeader = ({
  doEPICGeneratedFieldsMeetValidation,
  epicParameters,
  setShowToast
}) => {
  const inProgressEpicParameters = {
    icon: 'epic-in-progress-white-icon',
    imgAlt: 'epic in progress',
    imgId: 'epic-in-progress'
  };

  const completedEpicParameters = {
    icon: 'checked-red-white-bg-icon',
    imgAlt: 'completed',
    imgId: 'epic-completed'
  };

  const { icon, imgAlt, imgId } = doEPICGeneratedFieldsMeetValidation
    ? completedEpicParameters
    : inProgressEpicParameters;

  return (
    <div className='flex justify-between items-center'>
      <div className='flex items-center gap-2'>
        <Image
          alt={imgAlt}
          height={20}
          id={imgId}
          src={`${staticMediaStoreBaseURL}/icons/${icon}.svg`}
          width={20}
        />
        <div className='epic-font-style'>
          {['Event', 'Profile', 'Indicative', 'Code'].map((value) => (
            <span
              key={value}
              className='text-sm md:text-base pr-1.5'
            >
              <span className='font-bold'>{value[0]}</span>
              {value.slice(1)}
            </span>
          ))}
          <Text
            {...{
              className: 'md:text-base text-sm font-bold',
              content: '(EPIC)',
              HtmlTag: 'span'
            }}
          />
        </div>
      </div>
      {doEPICGeneratedFieldsMeetValidation && (
        <Image
          alt='copy'
          className='cursor-pointer'
          height={20}
          id='copy-epic'
          onClick={() =>
            generateEPICExplanationAndCopyToClipboard({
              epicParameters,
              setShowToast
            })
          }
          src={`${staticMediaStoreBaseURL}/icons/copy-white-icon.svg`}
          width={20}
        />
      )}
    </div>
  );
};

const EPICBrief = ({
  containerStyle = 'bg-brand-gradient',
  setShowToast,
  userEvent
}) => {
  const {
    userEventDetails: [
      {
        checkoutEvent = {},
        eventAddress = {},
        eventContactName,
        eventDate = '',
        eventVerticals,
        expectedGuestCount
      } = {}
    ] = [],
    user
  } = userEvent;
  const { hostSegment } = user || {};
  const requesterType = hostSegment?.name || null;

  const progressBarPercentage =
    getEPICGenerationCompletionPercentage(userEvent);

  const doEPICGeneratedFieldsMeetValidation =
    progressBarPercentage === '100.00';
  const showProgressBar = !doEPICGeneratedFieldsMeetValidation;
  const epicParameters = {
    city: eventAddress?.formattedAddress,
    eventDate,
    eventType: checkoutEvent?.event?.name,
    guests: expectedGuestCount,
    hostName: eventContactName,
    hostType: requesterType,
    verticals: eventVerticals
  };

  return (
    <div
      className={`flex flex-col gap-3 rounded-lg text-white p-4 ${containerStyle}`}
    >
      <EPICBriefHeader
        {...{
          doEPICGeneratedFieldsMeetValidation,
          epicParameters,
          setShowToast
        }}
      />
      {showProgressBar && <ProgressBar {...{ progressBarPercentage }} />}
      <EPICExplanationWithoutTooltip
        {...{ epicParameters, id: 'epic-explanation' }}
      />
    </div>
  );
};

export default EPICBrief;
